import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiArrowUpRight } = FiIcons;

const advantages = [
  { title: 'Get started without becoming an SEO expert', description: 'Tell us about your services, locations and voice. We handle the ongoing posting, replies and reporting.' },
  { title: 'Stay in control of what goes live', description: 'Let us publish for you, or choose an approval workflow when you want to review posts and replies first.' },
  { title: 'Know what is happening', description: 'Weekly updates, a monthly local ranking heatmap and a record of profile activity keep the work visible.' }
];

export default function FeaturesSection() {
  return (
    <section className="overflow-hidden bg-[#0b1423] py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <motion.div initial={{ opacity: 0, x: -25 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="relative">
          <div className="aspect-[4/3] overflow-hidden rounded-[2rem] border border-white/10">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=85&w=1200" alt="Marketing performance analytics on a screen" loading="lazy" className="h-full w-full object-cover" />
          </div>
          <div className="absolute bottom-5 left-5 max-w-[220px] rounded-2xl bg-[#3fc0fa] p-5 text-[#0b1423] shadow-xl sm:-bottom-6 sm:-right-6 sm:left-auto sm:p-7">
            <p className="text-xs font-bold uppercase tracking-wider">Your focus</p>
            <p className="mt-2 text-2xl font-black leading-tight">Running your business.</p>
          </div>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 25 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#3fc0fa]">Why managed beats DIY</p>
          <h2 className="mb-6 text-4xl font-black leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
            The work gets done. <span className="text-[#3fc0fa]">You get your time back.</span>
          </h2>
          <p className="mb-9 text-lg text-slate-300">For $399 a month, Local Momentum takes recurring local-marketing tasks off your plate—without hiring someone to post, reply and report every week.</p>
          <div className="space-y-6">
            {advantages.map((item) => (
              <div key={item.title} className="flex gap-4 border-t border-white/10 pt-5">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#3fc0fa]/15">
                  <SafeIcon icon={FiCheck} className="text-[#3fc0fa]" />
                </span>
                <div>
                  <h3 className="text-lg font-bold text-white">{item.title}</h3>
                  <p className="mt-1 leading-relaxed text-slate-400">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
          <Link to="/pricing" className="site-button mt-9 inline-flex items-center gap-2 rounded-full px-7 py-4 font-bold">
            See the full plan <SafeIcon icon={FiArrowUpRight} />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}